import { postText, requireUrl } from "../http.js";

export function createTeamsAdapter(config) {
    return {
        async connect() {
            requireUrl(config.endpoint, "Teams CART URL");
            return true;
        },
        async test() {
            return this.send("");
        },
        async send(text = "") {
            return postText(requireUrl(config.endpoint, "Teams CART URL"), text, {}, true);
        },
        async clear() {
            return this.send("");
        },
        async disconnect() {
            return true;
        },
    };
}
